import * as fromRouter from '@ngrx/router-store';
import { createFeatureSelector } from '@ngrx/store';
export var reducers = {
    routerReducer: fromRouter.routerReducer
};
export var getRouterState = createFeatureSelector('routerReducer');
var CustomSerializer = /** @class */ (function () {
    function CustomSerializer() {
    }
    CustomSerializer.prototype.serialize = function (routerState) {
        var url = routerState.url;
        var queryParams = routerState.root.queryParams;
        var state = routerState.root;
        while (state.firstChild) {
            state = state.firstChild;
        }
        var params = state.params;
        return { url: url, queryParams: queryParams, params: params };
    };
    return CustomSerializer;
}());
export { CustomSerializer };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/reducers/router.reducer.ts.pre-build-optimizer.js